
import type { Json } from "@/integrations/supabase/types";
import type { Database } from "@/integrations/supabase/types";

export type DbProfile = Database["public"]["Tables"]["profiles"]["Row"];

export interface FAQ {
  question: string;
  answer: string;
}

// Only extend DbProfile with truly optional fields that aren't in the database schema
export interface Profile extends DbProfile {
  email?: string;
  show_scheduling?: boolean;
  call_sms_widget?: boolean;
}

export type FormType = 'booking' | 'lead' | 'ai' | null;

export interface ContactFormData {
  name: string;
  email: string;
  phone: string;
  scheduledDate: string;
  message: string;
}

export interface ContactOption {
  id: string;
  icon: React.ReactNode;
  label: string;
  sublabel: string;
  action?: () => void;
  url?: string;
  iconBgColor: string;
  gradientColors: string;
  isPrimary?: boolean;
}

export interface ContactWidgetProps {
  profile: Profile;
}

export type WidgetPage = 'contact' | 'faqs';

export const parseFAQs = (faqs: Json | null): FAQ[] => {
  if (!faqs || !Array.isArray(faqs)) return [];
  return faqs.map(faq => ({
    question: (faq as any)?.question || '',
    answer: (faq as any)?.answer || ''
  }));
};

export const faqsToJson = (faqs: FAQ[]): Json => {
  return faqs as unknown as Json;
};
